import { http } from "api/http";

const disableAtomProIncomeTaxClients = (data: any) => {
  return http.put("/incometax-config/disableIncomeTaxClient", data);
};

const disableIncomeTaxClient = (id: number) => {
  return http.put(`/incometax-config/disableIncomeTax/${id}`);
};

const getDeletedIncometaxClients = ({ queryKey }) => {
  let { limit, offset, sort, search, query } = queryKey[1] || {};
  return http.get("/incometax-config/deletedClients", {
    params: {
      limit,
      offset,
      sort,
      search,
      ...query,
    },
  });
};
const exportdeletedIncometaxClient = (data) => {
  return http.post("/incometax-config/exportdeletedClients", data);
};

const enableIncomeTaxClient = (id) => {
  return http.put(`/incometax-config/enableIncomeTax/${id}`);
};

const enableBulkIncomeTaxClient = (data) => {
  return http.post(`/incometax-config/enableIncomeTax/bulk-restore`, data);
};

const getBulkSyncStatus = () => {
  return http.get("/incometax-config/bulkSyncStatus");
};

const updateEnableStatus = () => {
  return http.put(`/incometax-config/enableStatus`);
};

const updateDisableStatus = () => {
  return http.put(`/incometax-config/disableStatus`);
};

const incomeTaxScheduling = (data: any) => {
  return http.post(`/incometax-config/scheduling`, data);
};

const exportAtomProCredentials = () => {
  return http.get("/incometax-config/export-credentials");
};

const bulkUpdateCredentials = (data: FormData) => {
  return http.post(`/incometax-config/bulkupdate-credentials`, data);
};

const exportErrorList = (data: any) => {
  return http.post("/incometax-config/export-errors", data);
};

const getIncomeTaxAtomClient = ({ queryKey }: any) => {
  return http.get(`/incometax-config/atom-client/${queryKey[1]}`);
};

const incomeTaxClientTasks = ({ queryKey }: any) => {
  return http.get(`/incometax-config/incomeTaxClientTasks`, { params: { ...queryKey[1] } });
};

const createFyaNotice = (data: any) => {
  return http.post(`/incometax-config/fyaNotice`, data);
};

const createNoticeResponse = (data: any) => {
  return http.post(`/incometax-config/noticeResponse`, data);
};

const updateNoticeResponse = (data: any) => {
  return http.put(`/incometax-config/noticeResponse`, data);
};

const updateFyaNotice = (data: any) => {
  return http.put(`/incometax-config/fyaNotice`, data);
};

const deleteFyaNotice = ({ id }) => {
  return http.delete(`/incometax-config/fyaNotice/${id}`);
};

const addManualNoticeDueDate = (data: any) => {
  return http.post(`/incometax-config/manualDueDate`, data);
};

export {
  exportdeletedIncometaxClient,
  disableAtomProIncomeTaxClients,
  disableIncomeTaxClient,
  getDeletedIncometaxClients,
  enableIncomeTaxClient,
  getBulkSyncStatus,
  updateEnableStatus,
  updateDisableStatus,
  incomeTaxScheduling,
  exportAtomProCredentials,
  bulkUpdateCredentials,
  exportErrorList,
  getIncomeTaxAtomClient,
  incomeTaxClientTasks,
  createFyaNotice,
  updateFyaNotice,
  deleteFyaNotice,
  createNoticeResponse,
  addManualNoticeDueDate,
  updateNoticeResponse,
  enableBulkIncomeTaxClient
};
